// Hands a finished file to the browser. Only the task centre calls this
// (handoff §6d: anything that produces a file goes to the task centre, never
// a direct click-to-download); a screen starts a task instead.
export function download(filename: string, content: BlobPart, type: string) {
  try {
    const url = URL.createObjectURL(new Blob([content], { type }))
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 0)
  } catch {
    /* no download in this environment; an export is still recorded */
  }
}
